
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg","fill-rule":"evenodd","clip-rule":"evenodd","stroke-linejoin":"round","stroke-miterlimit":"2"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.321 7.996V18.25h1.358V7.996l3.162 3.064a.694.694 0 00.96 0 .643.643 0 000-.93L12.48 5.943a.694.694 0 00-.96 0L7.199 10.13a.643.643 0 000 .93.694.694 0 00.96 0l3.162-3.064z","fill-rule":"nonzero"}})])
          )
        }
      }
    